"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z_INDEX_DROPDOWN_MOBILE = exports.DROPDOWN_CONTENT_ACTIVE = exports.SUCCESS_TEXT_TWO = exports.SUCCESS_TEXT = exports.ERROR_TEXT_TWO = exports.ERROR_TEXT = exports.YEAR_INDEX = exports.ACTIVE_CLASS_INPUT = exports.BcInputDateConstants = exports.BcDateConstants = exports.DateFormate = exports.SIZE_DATE_STR = void 0;
var CALENDAR_N1 = 1;
var CALENDAR_N2 = 2;
var CALENDAR_N3 = 3;
var CALENDAR_N4 = 4;
var CALENDAR_N5 = 5;
var CALENDAR_N6 = 6;
var CALENDAR_N7 = 7;
var CALENDAR_N8 = 8;
var CALENDAR_N9 = 9;
var CALENDAR_N10 = 10;
var CALENDAR_N11 = 11;
var CALENDAR_N12 = 12;
var CALENDAR_N14 = 14;
var CALENDAR_N15 = 15;
var CALENDAR_N17 = 17;
var CALENDAR_N20 = 20;
var CALENDAR_N25 = 25;
var CALENDAR_N27 = 27;
var CALENDAR_N21 = 21;
var CALENDAR_N28 = 28;
var CALENDAR_N29 = 29;
var CALENDAR_N30 = 30;
var CALENDAR_N31 = 31;
var CALENDAR_N100 = 100;
var CALENDAR_N120 = 120;
var CALENDAR_N400 = 400;
var SM_BREAKPOINT_N576 = 576;
var PADDING_INPUT_N30 = 30;
var HOURS_N23 = 23;
var MINUTES_AND_SECONDS_N59 = 59;
var MILISECONDS_N999 = 999;
exports.SIZE_DATE_STR = 10;
var DateFormate;
(function (DateFormate) {
    DateFormate["fullDate"] = "fullDate";
    DateFormate["mediumDate"] = "mediumDate";
    DateFormate["shortDate"] = "shortDate";
})(DateFormate || (exports.DateFormate = DateFormate = {}));
var BcDateConstants = (function () {
    function BcDateConstants() {
    }
    BcDateConstants.MAX_SCREEN_WIDTH = SM_BREAKPOINT_N576;
    BcDateConstants.CALENDAR_CLASS = 'bc-calendar';
    BcDateConstants.HOLIDAY_CLASS = 'bc-calendar-holiday';
    BcDateConstants.CALENDAR_CLASS_ACTIVE = 'bc-calendar-active';
    BcDateConstants.DATE_INPUT_DATE_CLASS = 'bc-input-date';
    BcDateConstants.BC_INPUT_DATE_IOS_CLASS = 'bc-input-date-ios';
    BcDateConstants.BC_INPUT_PLACEHOLDER_IOS = 'bc-input-placeholder-ios';
    BcDateConstants.DATE_FORM_FIELD_CLASS = 'bc-form-field';
    BcDateConstants.RANGE_MOLECULE_CLASSES = 'bc-input-date-range';
    BcDateConstants.WEEK_CLASS = 'bc-calendar-week';
    BcDateConstants.TOP_BAR_SELECTOR_CLASS = 'bc-calendar-top-bar';
    BcDateConstants.CURRENT_SELECTION_CLASS = 'bc-calendar-current-selection';
    BcDateConstants.DAYS_CLASS = 'bc-calendar-days';
    BcDateConstants.TWO_CALENDARS_CLASS = 'bc-two-calendars';
    BcDateConstants.SCROLLABLE_CALENDARS_CLASS = 'bc-calendar-scrollable-calendars';
    BcDateConstants.FIX_UPPER_BUTTONS = 'bc-calendar-fix-upper-buttons';
    BcDateConstants.DISPLAYED_CALENDARS_CLASS = 'bc-calendar-displayed-month';
    BcDateConstants.MONTH_NAME_CLASS = 'bc-month';
    BcDateConstants.CONFIRM_CLASS = 'btn-confirm';
    BcDateConstants.CANCEL_CLASS = 'btn-cancel';
    BcDateConstants.RESTORE_CLASS = 'btn-restore';
    BcDateConstants.BC_TAG_FILTER = 'bc-tag-filter';
    BcDateConstants.BC_TAG_FILTER_ACTIVE = 'bc-tag-filter-active';
    BcDateConstants.STYLE_BORDER_SOLID = '2px solid';
    BcDateConstants.YEAR_CLASS = 'bc-year';
    BcDateConstants.NEXT_CLASS = 'next';
    BcDateConstants.PREV_CLASS = 'prev';
    BcDateConstants.SELECTED_DATE_CLASS = 'bc-calendar-selected-date';
    BcDateConstants.SELECTED_DATE_MONTH_CLASS = 'bc-calendar-selected-month';
    BcDateConstants.INSIDE_RANGE_CLASS = 'bc-calendar-inside-range';
    BcDateConstants.TODAY_CLASS = 'bc-calendar-today';
    BcDateConstants.OUTLINE_CLASS = 'outline-element';
    BcDateConstants.THIS_MONTH_OR_YEAR_CLASS = 'bc-calendar-this-month-or-year';
    BcDateConstants.DAY = 'day';
    BcDateConstants.MAC = 'Mac';
    BcDateConstants.ONTOUCHEND = 'ontouchend';
    BcDateConstants.UPPPER_BTNS_CLASS = 'bc-calendar-upper-btns';
    BcDateConstants.MONTHS_OR_YEARS_CLASS = 'bc-calendar-months-or-years';
    BcDateConstants.WEEK_SHORT = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
    BcDateConstants.WEEK_SHORT_ENGLISH = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    BcDateConstants.MONTHS_TEXT = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ];
    BcDateConstants.MONTHS_TEXT_ENGLISH = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    BcDateConstants.MONTHS_TEXT_SHORT = [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic',
    ];
    BcDateConstants.MONTHS_TEXT_SHORT_ENGLISH = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    BcDateConstants.LONG_MONTHS = [
        -1,
        0,
        CALENDAR_N2,
        CALENDAR_N4,
        CALENDAR_N6,
        CALENDAR_N7,
        CALENDAR_N9,
        CALENDAR_N11,
        CALENDAR_N12,
    ];
    BcDateConstants.NUMBERS = {
        CALENDAR_N1: CALENDAR_N1,
        CALENDAR_N2: CALENDAR_N2,
        CALENDAR_N3: CALENDAR_N3,
        CALENDAR_N4: CALENDAR_N4,
        CALENDAR_N5: CALENDAR_N5,
        CALENDAR_N6: CALENDAR_N6,
        CALENDAR_N7: CALENDAR_N7,
        CALENDAR_N8: CALENDAR_N8,
        CALENDAR_N9: CALENDAR_N9,
        CALENDAR_N10: CALENDAR_N10,
        CALENDAR_N11: CALENDAR_N11,
        CALENDAR_N12: CALENDAR_N12,
        CALENDAR_N14: CALENDAR_N14,
        CALENDAR_N15: CALENDAR_N15,
        CALENDAR_N17: CALENDAR_N17,
        CALENDAR_N20: CALENDAR_N20,
        CALENDAR_N25: CALENDAR_N25,
        CALENDAR_N27: CALENDAR_N27,
        CALENDAR_N21: CALENDAR_N21,
        CALENDAR_N28: CALENDAR_N28,
        CALENDAR_N29: CALENDAR_N29,
        CALENDAR_N30: CALENDAR_N30,
        CALENDAR_N31: CALENDAR_N31,
        CALENDAR_N100: CALENDAR_N100,
        CALENDAR_N120: CALENDAR_N120,
        CALENDAR_N400: CALENDAR_N400,
        HOURS_N23: HOURS_N23,
        MINUTES_AND_SECONDS_N59: MINUTES_AND_SECONDS_N59,
        MILISECONDS_N999: MILISECONDS_N999
    };
    BcDateConstants.SHORT_MONTHS = [CALENDAR_N3, CALENDAR_N5, CALENDAR_N8, CALENDAR_N10];
    BcDateConstants.STATE_DAYS = 'days';
    BcDateConstants.STATE_MONTHS = 'months';
    BcDateConstants.STATE_MONTH = 'month';
    BcDateConstants.STATE_YEARS = 'years';
    BcDateConstants.STATE_YEAR = 'year';
    BcDateConstants.STATE_RANGE = 'range';
    BcDateConstants.STATE_SPLIT = 'split';
    BcDateConstants.STATE_SELECT_MONTH = "month";
    BcDateConstants.STATE_SELECT_YEAR = "year";
    BcDateConstants.MOBILE_CALENDAR_CLASS = 'bc-calendar-mobile';
    BcDateConstants.MOBILE_CONFIRM_CLASS = 'bc-calendar-confirm-mobile';
    BcDateConstants.FAST_BUTTONS = 'fastButtons';
    BcDateConstants.BUTTONS_RANGE_CONTAINER_CLASS = 'bc-calendar-buttons-range-container';
    BcDateConstants.BUTTONS_SIMPLE_CONTAINER_CLASS = 'bc-calendar-buttons-simple-container';
    BcDateConstants.FIXED_CONTENT_CLASS = 'bc-calendar-fixed-content';
    BcDateConstants.MOBILE_CALENDAR_TITLE = 'Selecciona una fecha';
    BcDateConstants.MOBILE_TITLE_CLASS = 'mobile-title';
    BcDateConstants.DISABLED_DAY = 'bc-calendar-disabled-day';
    BcDateConstants.DISABLED_MONTH = 'bc-calendar-disabled-month';
    BcDateConstants.BTN_X_CLASS = 'btn-x';
    BcDateConstants.DATES_CLASS = 'dates';
    BcDateConstants.INPUT_TYPE_DATE = 'date';
    BcDateConstants.FROM_CLASS = 'from';
    BcDateConstants.TO_CLASS = 'to';
    BcDateConstants.RANGES = 'ranges';
    BcDateConstants.RANGES_TEXT = 'rangesText';
    BcDateConstants.TYPE_LINK = 'gray';
    BcDateConstants.CALENDAR_BUTTON = 'CalendarButton';
    BcDateConstants.CALENDAR_FILTER = 'CalendarFilter';
    BcDateConstants.CALENDAR_HOLIDAY = 'holidayDates';
    BcDateConstants.CALENDAR_EVENT_CHANGE_DATE = 'changeDateInput';
    BcDateConstants.BTN_CONFIRM_NO_VALIDATE = 'btnConfirmNoValidate';
    BcDateConstants.RESTORE_WITH_SETUP = 'restoreCalendarWithSetUp';
    BcDateConstants.CALENDAR_EVENT_SELECTED_DATE = 'selectedDateActual';
    BcDateConstants.DATE_SELECTION = 'date-selection';
    BcDateConstants.FORMAT_DATE = 'formatdate';
    BcDateConstants.SM_BREAKPOINT = SM_BREAKPOINT_N576;
    BcDateConstants.PADDING_INPUT = PADDING_INPUT_N30;
    BcDateConstants.MONTH_NUMBER = "month_number";
    BcDateConstants.ID = "id";
    BcDateConstants.ID_DAY = "DAY";
    BcDateConstants.ID_MONTH = "MONTH";
    BcDateConstants.ID_YEAR = "YEAR";
    BcDateConstants.GMT_CONSTANT = 'GMT';
    BcDateConstants.MILLISECONDS_CALCULATE = 1000;
    BcDateConstants.MINUTES_CALCULATE = 60;
    BcDateConstants.DAY_HOURS_CALCULATE = 24;
    BcDateConstants.MILLISECONDS_CALCULATE_DAY = 60000;
    BcDateConstants.PLACEHOLDER_IOS = "DD/MM/AAAA";
    BcDateConstants.FORMATTED_DATE_YEAR = "MM/dd/yyyy";
    BcDateConstants.VALIDATE_INPUT = 'validateInput';
    BcDateConstants.BC_CALENDAR_SAFARI_REGEX = /^((?!chrome|android).)*safari/i;
    BcDateConstants.OPERATIONS = 'operations';
    return BcDateConstants;
}());
exports.BcDateConstants = BcDateConstants;
var BcInputDateConstants = (function () {
    function BcInputDateConstants() {
    }
    BcInputDateConstants.ofDate = 'de';
    BcInputDateConstants.full = 'full';
    BcInputDateConstants.medium = 'medium';
    return BcInputDateConstants;
}());
exports.BcInputDateConstants = BcInputDateConstants;
exports.ACTIVE_CLASS_INPUT = 'bc-active';
exports.YEAR_INDEX = 2;
exports.ERROR_TEXT = 'errorText';
exports.ERROR_TEXT_TWO = 'errorTextTwo';
exports.SUCCESS_TEXT = 'successText';
exports.SUCCESS_TEXT_TWO = 'successTextTwo';
exports.DROPDOWN_CONTENT_ACTIVE = 'bc-dropdown-content-active';
exports.Z_INDEX_DROPDOWN_MOBILE = 999;
